import { EBillingStatus, IBillingStatusState } from './types';

const DEFAULT_STATE = { status: EBillingStatus.OK };

export function billingStatus(state: IBillingStatusState) {
  return state || DEFAULT_STATE;
}
